import AbstractColumnTemplate from "../AbstractColumnTemplate.js";

/**
 * Abstract class for the templates handling a collection of sub-columns.
 *
 * @abstract
 */
export default class AbstractGroupColumnTemplate extends AbstractColumnTemplate {}
